// @flow

import type { PropsSchema, BasicProps, EasyAction } from '../../type'

import * as React from 'react'
import computeData from '../hoc/computeData'
import $ from 'jquery'
import css from './Swiper.scss'
type Props = BasicProps & {
  style: { [string]: string },
  swiperParam: string,
  children: React.ChildrenArray<React.Node>
};
@computeData()
export default class SwiperComp extends React.PureComponent<Props> {
  swiper: any;
  static schema: PropsSchema = [
    {
      title: '动画参数',
      key: 'swiperParam',
      type: 'code'
    },
    'separator',
    {
      type: 'style'
    },
    'separator',
    {
      type: 'event',
      title: 'swiper切换',
      event: 'onTransitionEnd'
    }
  ];

  static actions: EasyAction[] = [
    {
      title: '切换到指定slide',
      name: 'slideTo',
      dataSchema: [
        {
          key: 'slideIndex',
          title: '指定slide的index',
          required: true
        }
      ]
    }
  ];

  constructor (props: Props) {
    super(props)
    this.swiperPromise = Promise.all([
      import('swiper/dist/js/swiper'),
      import('swiper/dist/css/swiper.min.css')
    ]).then(([Swiper]) => {
      return Swiper
    })
  }

  swiperPromise: Promise<*>;

  componentDidMount () {
    this.swiperPromise.then(Swiper => {
      const { swiperParam, jsEnv, callActions } = this.props
      const paramObj = jsEnv.runCode(swiperParam)
      $(this.refs.swiperWrapper)
        .children()
        .addClass('swiper-slide')
      if (paramObj) {
        paramObj.on = {
          transitionEnd: function () {
            callActions('onTransitionEnd', this.activeIndex)
          }
        }
        if (paramObj.pagination) {
          paramObj.pagination.bulletClass = css.myBullet
          paramObj.pagination.bulletActiveClass = css.myBulletActive
        }
      }
      this.swiper = new Swiper(this.refs.swiper, paramObj); // eslint-disable-line
    })
  }

  actionSlideTo = (
    { slideIndex }: { slideIndex: string },
    dynamicData: any
  ) => {
    const { jsEnv } = this.props
    const swiper = this.swiper
    swiper.slideTo(
      jsEnv.getStringWithAdditionCtx(slideIndex, dynamicData),
      1000,
      false
    )
  };

  render () {
    if (!this.props.visible) {
      return null
    }
    const { id, style, children } = this.props
    return (
      <div id={id} style={style} className='swiper-container' ref='swiper'>
        <div className='swiper-wrapper' ref='swiperWrapper'>
          {children}
        </div>
        <div className='swiper-pagination' style={{ bottom: '6px' }} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/basic/Swiper.js